import { intersperse } from 'ramda';
import * as React from 'react';
import { Item } from '../../../../../../../components/Grid';
import HistoryRow from '../../../../../../../components/HistoryRow';
import HistoryRowControls from '../../../../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../../../../components/HistoryRowListing';
import { IHistoryContext } from '../../../../../../../containers/FormContextHandler';
import { sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../../utils/functions';
import { mcDonald2017ResultForHistoryView } from '../../../../../utils/MS';
import { msDiagnosticCriteria } from 'neuro-schemas';

const formatCriteriaType = (d: IMSCriteria, fm: (id: string) => string): React.JSX.Element => {
  return (
    <div>
      {fm(`diagnosis.msDiagnosticCriteria.criteria.opts.${d.criteria ?? 'empty'}`)}
      {d.revision ? ' ' : ''}
      {d.revision ? fm(`diagnosis.msDiagnosticCriteria.mcDonaldRevision.opts.${d.revision}`) : ''}
    </div>
  );
};

const formatDiagnosticCriteriaAnswer = (d: IMSCriteria, fm: (id: string) => string): React.JSX.Element | string => {
  if (['poser', 'schumacher'].includes(d.criteria || '') || ['2001', '2005', 'unknown'].includes(d.revision || ''))
    return <span>{'-'}</span>;
  if (d.criteria === 'mcdonald') {
    if (d.revision === '2010')
      return ['1', '2', '3', '4'].includes(d.mcDonald2010 || '')
        ? fm('diagnosis.msDiagnosticCriteria.history.rr.rr')
        : d.mcDonald2010 === '5'
          ? fm('diagnosis.msDiagnosticCriteria.history.pp.pp')
          : fm('general.empty');
    const resultArr = intersperse('comma', mcDonald2017ResultForHistoryView(d));
    if (d.revision === '2017')
      return (
        <React.Fragment>
          {resultArr.map(
            (r: string, index: number): React.JSX.Element => (
              <React.Fragment key={r + index}>{fm(`diagnosis.msDiagnosticCriteria.history.${r}`)}</React.Fragment>
            ),
          )}
        </React.Fragment>
      );
    if (d.revision === '2024') {
      const result = msDiagnosticCriteria.utils.mcDonald2024CriteriaMet(d);
      if (result === null) return '-';
      const formatted = fm(`diagnosis.msDiagnosticCriteria.mcDonald2024DiagnosticCriteria.results.${result}`);
      return formatted;
    }
  }
  return fm('general.unknown');
};

const MSDiagnosticCriteriaHistory = ({
  documents,
  startEdit,
  view,
  fm = (): string => '',
}: IHistoryContext<IMSCriteria>): React.JSX.Element => {
  const msCriteria = documents?.toSorted((d1: IMSCriteria, d2: IMSCriteria) => sortPartialDate(d2.date, d1.date));
  return (
    <HistoryRow
      headerText={fm('diagnosis.msDiagnosticCriteria.history.title')}
      rowButton={
        startEdit
          ? newButton('msDiagnosticCriteria', startEdit({}, 'msDiagnosticCriteria'), 'general.new', 15)
          : undefined
      }
    >
      <HistoryRowListing
        documents={msCriteria}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={3}>{fm('diagnosis.msDiagnosticCriteria.history.usedCriteria')}</Item>
            <Item xs={7}>{fm('diagnosis.msDiagnosticCriteria.history.criteriasAreFullfilled')}</Item>
          </>
        }
        contentFormat={(d: IMSCriteria): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {d.date && formatPartialDate(d.date)}
            </Item>
            <Item xs={3}>{formatCriteriaType(d, fm)}</Item>
            <Item xs={4}>{formatDiagnosticCriteriaAnswer(d, fm)}</Item>
            <Item xs={3}>
              {startEdit ? <HistoryRowControls document={d} startEdit={startEdit} view={view} /> : null}
            </Item>
          </>
        )}
      />
    </HistoryRow>
  );
};

export default MSDiagnosticCriteriaHistory;
